var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_90c1d37149d4af5d16b2a9cd66d9235a",
    "data-name": "90c1d37149d4af5d16b2a9cd66d9235a",
    transform: "translate(-2 -2)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    cx: 18.5,
    cy: 18.5,
    r: 18.5,
    transform: "translate(2 2)",
    fill: "#cae8ff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    cx: 5.5,
    cy: 5.5,
    r: 5.5,
    transform: "translate(15 9)",
    fill: "#494f54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M17,14A11.129,11.129,0,0,0,6.009,23.9a1.834,1.834,0,0,0,.809,1.705,18.477,18.477,0,0,0,20.369,0A1.834,1.834,0,0,0,28,23.9,11.129,11.129,0,0,0,17,14Z",
    transform: "translate(3.335 10.005)",
    fill: "#494f54"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.b2d577232841dce3cd7c643557d6409e.svg";
export { ForwardRef as ReactComponent };